import React from 'react';
import UserRow from '../molecules/UserRow';
import { User } from '../types/User';

interface UserTableProps {
  users: User[];
  roleOptions: { label: string; value: string }[];
  onRoleChange: (username: string, roles: string) => void;
  onSaveAll: () => void;
}

const UserTable: React.FC<UserTableProps> = ({ users, roleOptions, onRoleChange, onSaveAll }) => (
  <div className="table-responsive mt-4" style={{ overflow: 'visible' }}>
    <table className="table">
      <thead className="TableHeader">
        <tr>
          <th className='p-3 w-20'>First name</th>
          <th className='p-3 w-20'>Last name</th>
          <th className='p-3 w-30'>Email</th>
          <th className='p-3 w-30'>Roles</th>
        </tr>
      </thead>    
      <tbody>
        {users.map((user) => (
          <UserRow
            key={user.username}
            user={user}
            roleOptions={roleOptions}
            onRoleChange={onRoleChange}
          />
        ))}
      </tbody>
    </table>
    <div className="d-flex justify-content-end mt-3">
      <button className="btn SaveBtn" onClick={onSaveAll}>
        Save
      </button>
    </div>
  </div>
);

export default UserTable;
